export default __webpack_public_path__ + "static/media/h3.a414858e.jpg";